type AttachmentItem =
  | string
  | {
      id?: string;
      file_name?: string;
      file_url?: string;
      file_type?: string;
    };

interface AttachmentListProps {
  attachments?: AttachmentItem[];
  file?: string;
}

export const AttachmentList: React.FC<AttachmentListProps> = ({
  attachments,
  file,
}) => {
  // Normalize to URL strings
  const files: string[] = attachments?.length
    ? attachments
        .map((item) => (typeof item === "string" ? item : item.file_url))
        .filter((url): url is string => Boolean(url))
    : file
      ? [file]
      : [];

  return (
    <div className="d-flex flex-column gap-1">
      {/* <span>Attachments :</span> */}

      {files.length === 0 ? (
        <span>No Attachments</span>
      ) : (
        <>
          {files.map((url, idx) => {
            const fileName = decodeURIComponent(url.split("/").pop() || "file");
            return (
              <>
                <div className="d-flex gap-3 align-items-center">
                  <span>{idx + 1}</span>

                  <a
                    href={url}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="text-decoration-underline"
                    title={fileName || `Attachment ${idx + 1}`} // 👈 hover shows full name
                  >
                    <span
                      className="badge bg-secondary text-truncate"
                      style={{
                        fontSize: "0.75rem",
                        maxWidth: "200px", // 👈 controls ~20–30 chars
                        display: "inline-block",
                        whiteSpace: "nowrap",
                        overflow: "hidden",
                        textOverflow: "ellipsis",
                        cursor: "pointer",
                      }}
                    >
                      {fileName || `Attachment ${idx + 1}`}
                    </span>
                  </a>
                </div>
              </>
            );
          })}
        </>
      )}
    </div>
  );
};
